import React, { PureComponent } from 'react';
import get from 'lodash/get';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

// TODO: isRequired from fields
class AssetFormCustomFields extends PureComponent {
  getCustomFields = () => [
    ...get(this.props.values, '_account._customFields', []),
    ...get(this.props.values, '_subaccount._customFields', []),
  ];

  render = () => {
    const { t = () => {} } = this.props;

    const customFields = this.getCustomFields();

    return (
      <div className="row mt-3 align-items-center bbottom">
        <div className="col-sm-12">
          <h5>
            <b>{t('assets.section.customFields')}</b>
          </h5>
          <br />
        </div>
        {customFields.map((customField) => (
          <div className="col-sm-6 col-md-4 col-lg-3" key={customField.key}>
            <Form.FieldInput
              name={customField.key}
              label={customField.label}
              handleChange={this.props.handleValueChange}
              value={this.props.values[customField.key]}
            />
          </div>
        ))}
      </div>
    );
  };
}
export default translate()(AssetFormCustomFields);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormCustomFields.js